import { shallowEqual } from "react-redux";

import { api } from "../api";
import type { AppAction } from "../actions";
import type { RootState } from "../state";
import { routerReducer } from "./routerReducer";
import { environmentSlice } from "../slices";
import { uiReducer } from "./uiReducer";

export function rootReducer(
  state: RootState | undefined,
  action: AppAction
): RootState {
  const newState: RootState = {
    [api.reducerPath]: api.reducer(state?.[api.reducerPath], action),
    environment: environmentSlice.reducer(state?.environment, action),
    router: routerReducer(state?.router, action),
    ui: uiReducer(state, action),
  };

  return state && shallowEqual(state, newState) ? state : newState;
}
